<template>
  <div class="emp-layout">
    <img :src="srcImage" />
    <slot name="messages"></slot>
    <loading-btn
      v-if="loadingBtn || btnText !== ''"
      :loading="loading"
      :disabled="disabled"
      variant="primary"
      @click="btnClicked"
    >
      {{ btnText }}
    </loading-btn>
    <b-btn
      v-else-if="!loadingBtn || btnText !== ''"
      variant="primary"
      @click="btnClicked"
      >{{ btnText }}</b-btn
    >
    <slot></slot>
  </div>
</template>

<script>
import LoadingBtn from "../LoadingBtn/LoadingBtn.vue";
export default {
  components: { LoadingBtn },
  name: "EmptyList",
  props: {
    srcImage: { type: String, required: true },
    btnText: { type: String, required: true },
    loadingBtn: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  methods: {
    btnClicked: function() {
      this.$emit("btnCreateClicked");
    }
  }
};
</script>

<style lang="scss">
.emp-layout {
  width: 80%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 30px;

  @media (max-width: 992px) {
    width: 100%;
  }

  &-note span {
    color: #ffc107;
    font-weight: 600;
  }

  img {
    width: 60%;
    margin-bottom: 10px;

    @media (max-width: 767px) {
      width: 100%;
    }
  }
}
</style>
